import React from "react";
import {Localizer} from "../../../infrastructure/localization/localizer";
import classNames from "classnames";

type vejledningDaysSinceLastCellProps = {
    days?: number;
}

export const VejledningDaysSinceLastCell = ({days}: vejledningDaysSinceLastCellProps) => {
    const getDynamicClasses = (days?: number): string => {
        if (days === null || days === undefined) return "badge-default";
        switch (true) {
            case (days >= 0 && days <= 30):
                return "success-light";
            case (days > 30 && days <= 90):
                return "badge-warning-light";
            case (days > 90):
                return "badge-danger-light danger-dark";
            default:
                return "badge-default";
        }
    };

    const text = days == null
        ? Localizer.global_none()
        : `${days} ${Localizer.global_days()}`

    return (
        <div className={classNames("badge badge-pill badge-lg font-weight-bold min-w-140", getDynamicClasses(days))}>
            {text}
        </div>
    )
};
